import OnvoBase from "./base.js";

import { OnvoAccounts } from "./accounts/index.js";
import { OnvoTeams } from "./teams/index.js";
import { OnvoEmbedUsers } from "./embed_users/index.js";
import { OnvoDatasources } from "./datasources/index.js";
import { OnvoAutomations } from "./automations/index.js";
import { OnvoDashboards } from "./dashboards/index.js";
import { OnvoDashboard } from "./dashboard/index.js";
import { OnvoEmbedUser } from "./embed_user/index.js";
import { OnvoDatasource } from "./datasource/index.js";
import { OnvoQuestions } from "./questions/index.js";
import { OnvoAutomation } from "./automation/index.js";
import { OnvoWidget } from "./widget/index.js";
import { OnvoSessions } from "./sessions/index.js";
import { OnvoWidgets } from "./widgets/index.js";
import { OnvoQuestion } from "./question/index.js";
import { OnvoUtils } from "./utils/index.js";
import { OnvoLogs } from "./logs/index.js";
import { OnvoIntegrations } from "./integrations/index.js";
import { OnvoIntegration } from "./integration/index.js";

export class Onvo extends OnvoBase {
    accounts: OnvoAccounts;
    teams: OnvoTeams;
    embed_users: OnvoEmbedUsers;
    datasources: OnvoDatasources;
    automations: OnvoAutomations;
    dashboards: OnvoDashboards;
    questions: OnvoQuestions;
    widgets: OnvoWidgets;
    sessions: OnvoSessions;
    utils: OnvoUtils;
    logs: OnvoLogs;
    integrations: OnvoIntegrations;

    automation: (automationId: string) => OnvoAutomation;
    dashboard: (dashboardId: string) => OnvoDashboard;
    embed_user: (embedUserId: string) => OnvoEmbedUser;
    datasource: (datasourceId: string) => OnvoDatasource;
    widget: (widgetId: string) => OnvoWidget;
    question: (questionId: string) => OnvoQuestion;
    integration: (integrationId: string) => OnvoIntegration;

    constructor(apiKey: string, options?: { endpoint: string }) {
        super(apiKey, options);

        this.accounts = new OnvoAccounts(apiKey, options);
        this.teams = new OnvoTeams(apiKey, options);
        this.embed_users = new OnvoEmbedUsers(apiKey, options);
        this.datasources = new OnvoDatasources(apiKey, options);
        this.automations = new OnvoAutomations(apiKey, options);
        this.dashboards = new OnvoDashboards(apiKey, options);
        this.questions = new OnvoQuestions(apiKey, options);
        this.sessions = new OnvoSessions(apiKey, options);
        this.widgets = new OnvoWidgets(apiKey, options);
        this.utils = new OnvoUtils(apiKey, options);
        this.logs = new OnvoLogs(apiKey, options);
        this.integrations = new OnvoIntegrations(apiKey, options);

        this.dashboard = (dashboardId: string) => {
            return new OnvoDashboard(dashboardId, apiKey, options);
        };

        this.integration = (integrationId: string) => {
            return new OnvoIntegration(integrationId, apiKey, options);
        };

        this.embed_user = (embedUserId: string) => {
            return new OnvoEmbedUser(embedUserId, apiKey, options);
        };

        this.datasource = (datasourceId: string) => {
            return new OnvoDatasource(datasourceId, apiKey, options);
        };
        this.automation = (automationId: string) => {
            return new OnvoAutomation(automationId, apiKey, options);
        };
        this.widget = (widgetId: string) => {
            return new OnvoWidget(widgetId, apiKey, options);
        };

        this.question = (questionId: string) => {
            return new OnvoQuestion(questionId, apiKey, options);
        };

    }
}
